<template>
<svg viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-psm-xinghao`]" width="1em" height="1em" v-bind="$attrs"><path d="M98.4322545,0 C103.712287,0 108,4.28771256 108,9.56774547 L108,98.4322545 C108,103.712287 103.712287,108 98.4322545,108 L9.56774547,108 C4.28771256,108 0,103.712287 0,98.4322545 L0,9.56774547 C0,4.28771256 4.28771256,0 9.56774547,0 Z M98.743,59 L9.256,59 L9.25671969,98.4322545 C9.25671969,98.5794901 9.35902654,98.7028306 9.49643012,98.7350659 L9.56774547,98.7432803 L98.4322545,98.7432803 C98.6040293,98.7432803 98.7432803,98.6040293 98.7432803,98.4322545 L98.743,59 Z M91,72.5985121 L91,85 L17,85 L17,72.5985121 L91,72.5985121 Z M98.4322545,9.25671969 L9.56774547,9.25671969 C9.39742183,9.25671969 9.25671969,9.39742183 9.25671969,9.56774547 L9.256,50 L98.743,50 L98.7432803,9.56774547 C98.7432803,9.42175378 98.6399073,9.29752482 98.503113,9.26501026 L98.4322545,9.25671969 Z M47.8358,23 L47.8358,35.4014879 L17,35.4014879 L17,23 L47.8358,23 Z M91,23 L91,35.4014879 L60.1642,35.4014879 L60.1642,23 L91,23 Z" transform="translate(11 11)" :fill="useCurrentColor ? 'currentColor' : '#4E5969'" fill-rule="nonzero"/></svg>
</template>
<script>

export default {
  name: 'IconPsmXinghao',
  props: {
    prefix: {
        type: String,
        default: 'psm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
